export default "__VITE_ASSET__CFIBmkBu__"